module.exports = __webpack_public_path__ + "img/fastcharger-disabled-semipublic.c7752e99.svg";